<template>
   <HeaderDash />
   <SideMenu /> 
   <AddMemberProject /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/team/dashboard/HeaderDash.vue'
import SideMenu from '@/components/team/dashboard/SideMenu.vue'
import AddMemberProject from '@/components/team/dashboard/modules/project/AddMember-Project.vue'

export default 
{
  name: 'AddMember-Project',
  components: 
  {
    HeaderDash,
    SideMenu,
    AddMemberProject
  }
}
</script>
<style>


</style>
